export default {
  FETCH_WALLET_REPORT: 'FETCH_WALLET_REPORT',
  FETCH_WALLET_REPORT_SUCCESS: 'FETCH_WALLET_REPORT_SUCCESS',
  DOWNLOAD_WALLET_REPORT: 'DOWNLOAD_WALLET_REPORT'
}
